import { Grid, Typography } from '@mui/material';
import { PqrTimesDataProps } from './props';
import { usePqrTimesData } from './hook';
import FieldText from '../../../../../components/general/fields/fieldText';
import AutocompleteField from '../../../../../components/general/fields/autocompleteField';
import { formatParams } from '../../../../../../shared/utils/params';

export const PqrTimesDate = (props: PqrTimesDataProps) => {
    const { formik, typesClassification } = usePqrTimesData(props);

    return (
        <Grid
            container
            spacing={{ xs: 1.5, md: 1.5 }}
            columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
            pt="20px"
        >
            <Grid item xs={12}>
                <Typography style={{ fontWeight: 'bold', color: '#000' }}>
                    Fecha Estado
                </Typography>
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Fecha Estado 1"
                    name="typeSacTime"
                    size="small"
                    onBlur={formik.handleBlur}
                    touched={formik.touched.typeSacTime}
                    errors={formik.errors.typeSacTime}
                    value={'SAC'}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(typesClassification)}
                    label="Certificación"
                    name="typeClassificationSacTime"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.typeClassificationSacTime}
                    errors={formik.errors.typeClassificationSacTime}
                    value={formik.values.typeClassificationSacTime}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue('typeClassificationSacTime', value)
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Número de Días"
                    name="sacTime"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.sacTime}
                    errors={formik.errors.sacTime}
                    value={formik.values.sacTime}
                    onChange={formik.handleChange}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Fecha Estado 2"
                    name="typeFuragTime"
                    size="small"
                    errors={formik.errors.typeFuragTime}
                    value={'Normativa'}
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <AutocompleteField
                    data={formatParams(typesClassification)}
                    label="Certificación"
                    name="typeClassificationFuragTime"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.typeClassificationFuragTime}
                    errors={formik.errors.typeClassificationFuragTime}
                    value={formik.values.typeClassificationFuragTime}
                    onChangeValue={(value: any) =>
                        formik.setFieldValue(
                            'typeClassificationFuragTime',
                            value
                        )
                    }
                />
            </Grid>
            <Grid item xs={12} sm={6} md={4}>
                <FieldText
                    label="Número de Días"
                    name="furagTime"
                    size="small"
                    required
                    onBlur={formik.handleBlur}
                    touched={formik.touched.furagTime}
                    errors={formik.errors.furagTime}
                    value={formik.values.furagTime}
                    onChange={formik.handleChange}
                />
            </Grid>
        </Grid>
    );
};
